const { NavigationRefs } = require('components/infosite/navigation/navigation-refs');

/* global window */
const { inject, observer } = require('mobx-react');
const { withRouter } = require('react-router-dom');
const React = require('react');

const { AbacusControl, AbacusExperiment, AbacusVariant } = require('bernie-abacus');
const { ErrorBoundary, ViewLarge, Viewport, ViewSmall } = require('bernie-view');
const { QueryRoute } = require('bernie-core');
const { withLocalization } = require('bernie-l10n');

const { PageName } = require('constants/pages');

// Components
const { ChatBot } = require('components/common/chat-bot');
const { ActivityRecommendationsWrapper } = require('components/infosite/activity-recommendations');
const { BentoBox } = require('bento/bento-box.tsx');
const { BentoPortion } = require('bento/bento-portion.tsx');
const { BentoSideDish } = require('bento/bento-side-dish.tsx');
const { DatelessFaqs } = require('components/common/faq/dateless-faqs');
const { ErrorLink } = require('components/infosite/error-link');
const { FavoriteButton } = require('components/common/shortlist/favorite-button');
const { GalleryByCategories } = require('components/infosite/property-details/gallery-by-categories');
const { InfositeMessagingCard } = require('components/infosite/infosite-messaging-card');
const { MainRegion } = require('components/layout/pages/main-region');
const { MapAccess } = require('components/infosite/property-details/map-access');
const { MasterPage } = require('components/layout/pages/master-page');
const { MesoFooter } = require('components/meso/meso-footer');
const { MesoIntentMediaExp } = require('components/meso/meso-intent-media-exp');
const { MesoSideRail } = require('components/meso/meso-side-rail');
const { MultiItem } = require('components/multi-item');
const { NavigationBar } = require('components/infosite/navigation/navigation-bar');
const { NavigationRegion } = require('components/layout/pages/navigation-region');
const { NoReviews } = require('components/infosite/property-details/no-reviews');
const { PropertyDetails } = require('components/infosite/property-details');
const { PropertyInformation } = require('components/infosite/property-information');
const { PropertySummary } = require('components/infosite/property-summary');
const { ReviewsOnInfosite } = require('components/infosite/property-details/reviews-on-infosite');
const { RewardsEducationDialog } = require('components/common/rewards-education-dialog');
const { RoninPropertyDetails } = require('components/infosite/property-details/ronin-property-details');
const { roomsAndRatesLoadable } = require('components/infosite/rooms-and-rates/loadable');
const { SchemaOrgScript } = require('components/common/schema-org-script/schema-org-script');
const { SideRailRegion } = require('components/layout/pages/side-rail-region');
const { SimilarHotels } = require('components/infosite/similar-hotels/similar-hotels');
const { SleepingArrangementsWrapper } = require('components/infosite/property-sleeping-arrangements');
const { WelcomeNotification } = require('components/common/welcome-notification');
const { WhatsAroundCard } = require('components/infosite/whats-around/whats-around-card');

const MasterPageSideRailTypes = MasterPage.wrappedComponent.sideRailTypes;
const MasterPageToolbarTypes = MasterPage.wrappedComponent.toolbarTypes;

@withLocalization
@withRouter
@inject(
  'context',
  'searchResults',
  'currentHotel',
  'page',
  'uiPage',
  'analytics',
  'routeStore',
  'layerManager',
  'multiItem',
  'virtualAgentControlStore'
)
@observer
class Infosite extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      forceHistoryPush: false,
      roomsAndRatesTarget: undefined
    };

    this.pageShowEvents = this.pageShowEvents.bind(this);
    this.goBack = this.goBack.bind(this);
    this.forceHistoryPushOnGoBack = this.forceHistoryPushOnGoBack.bind(this);

    if (props.page && props.page.setPageName) {
      props.page.setPageName(PageName.INFOSITE);
    }

    this.setRoomsAndRatesTarget = this.setRoomsAndRatesTarget.bind(this);

    if (
      this.props.multiItem &&
      this.props.multiItem.isMixMatchEnabled &&
      typeof this.props.multiItem.getOrCreateCart === 'function' &&
      !this.props.multiItem.isPackageShoppingPath()
    ) {
      this.props.multiItem.getOrCreateCart(this.props.context);
    }
  }

  componentDidMount() {
    const { analytics, context, virtualAgentControlStore } = this.props;
    analytics.markPageUsable();
    // Mobile safari uses the back-forward cache meaning when a user clicks back
    // from CKO to HIS the spinner is still showing and the components do not re render,
    // need to manually dismiss this from a previously attached event.
    window.addEventListener('pageshow', this.pageShowEvents);
    window.scrollTo(0, 0);

    virtualAgentControlStore.injectVirtualAgentControl(
      virtualAgentControlStore.getVirtualAgentControl(),
      analytics,
      context,
      PageName.INFOSITE
    );
  }

  componentDidUpdate(prevProps) {
    const { layerManager, routeStore, uiPage, location, history } = this.props;

    const layer = layerManager && layerManager.length;

    if (!layer && routeStore.queryParams.scrollPosition) {
      uiPage.setFocusItem(routeStore.queryParams.scrollPosition);
      const query = routeStore.mergeQueryString(routeStore.search, null, key => !key.startsWith('scrollPosition'));
      const queryCombinerFunction = (prevQuery, newQuery) => newQuery;
      routeStore.updateSearch(query, undefined, true, queryCombinerFunction);
    } else if (location && prevProps.location && location.pathname !== prevProps.location.pathname && history.action === 'PUSH') {
      window.scrollTo(0, 0);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.pageShowEvents);
  }

  pageShowEvents() {
    this.props.uiPage.hideProgressIndicator();
  }

  setRoomsAndRatesTarget(roomsAndRatesTarget) {
    this.setState({
      roomsAndRatesTarget
    });
  }

  forceHistoryPushOnGoBack() {
    this.props.searchResults.clearDefaultRequestFields();
    this.setState({
      forceHistoryPush: true
    });
  }

  goBack(e) {
    const { analytics, routeStore, history, currentHotel, l10n } = this.props;
    const infositeContext = currentHotel && currentHotel.offers && currentHotel.offers.infositeContext;
    const backToHsrUrl = infositeContext && infositeContext.backToHsrUrl;

    if (analytics) {
      analytics.trackEvent('.BackToSearch', l10n.formatText('hotels.infosite.backToSearchResults.linkText'), {});
    }

    if (this.state.forceHistoryPush || routeStore.navigationDepth <= 0) {
      history.push(backToHsrUrl);
    } else {
      e.preventDefault();
      routeStore.goBack();
    }
  }

  renderLayout() {
    const { currentHotel, page, l10n, route, context, multiItem } = this.props;
    const { roomsAndRatesTarget } = this.state;

    const {
      searchCriteria,
      hotel,
      hotelId,
      isFailure,
      loadingOffers,
      messagingCardModel,
      offers,
      reviews,
      similarHotels,
      similarHotelsDateless,
      toolbar = {}
    } = currentHotel || {};
    const { hotelName, navigationBarTabList, propertyFaqs, shortlistModel, vrInquiryChatbotViewModel } = hotel || {};
    const stickyOffer = offers && offers.stickyOffer;
    const priceGuarantee = offers && offers.propertyInfo && offers.propertyInfo.priceGuarantee;
    const destination = searchCriteria && searchCriteria.destination;
    const isDateless = searchCriteria && searchCriteria.isDateless;
    const infositeContext = offers && offers.infositeContext;
    const backToHsrUrl = infositeContext && infositeContext.backToHsrUrl;
    const rewardsEducation = offers && offers.rewardsDialogContent && offers.rewardsDialogContent.rewardsEducation;
    const structuredData = context && context.viewModelResponse && context.viewModelResponse.structuredData;
    const siteId = context && context.site && context.site.id;
    const trafficTestBucket =
      context &&
      context.viewModelResponse &&
      context.viewModelResponse.flexContext &&
      context.viewModelResponse.flexContext.experimentContext &&
      context.viewModelResponse.flexContext.experimentContext.experiments &&
      context.viewModelResponse.flexContext.experimentContext.experiments.FAQ_on_PDP_Traffic_Test;
    if (!page.seo) {
      page.title = `${hotelName} ${destination ? `(${destination})` : ''}`;
    }
    const favoriteButton = shortlistModel && shortlistModel.meta && shortlistModel.meta.hotelId && (
      <FavoriteButton
        shortlistModel={shortlistModel}
        labelSave={l10n.formatText('hotels.infosite.shortlist.saveToList.a11yLabel')}
        labelRemove={l10n.formatText('hotels.infosite.shortlist.removeFromList.a11yLabel')}
        category="hotel"
        onSaveMessage={l10n.formatText('hotels.shortlist.saveToList.notification', hotelName)}
        id={`favorite-${hotelId}`}
        {...hotel}
        reviews={reviews}
      />
    );
    const masterProps = {
      className: 'infosite',
      dataStid: 'infosite-page-container',
      pageUsable: true,
      route,
      searchCriteria
    };

    return (
      <MasterPageWrapper {...masterProps}>
        <NavigationRegion className="navigation-bar-region constrained">
          <PropertySummary
            {...hotel}
            reviews={reviews}
            backToHsrUrl={backToHsrUrl}
            name={toolbar.name}
            goBack={this.goBack}
            favoriteButton={favoriteButton}
            currentHotel={currentHotel}
            roomsAndRatesTarget={roomsAndRatesTarget}
            stickyOffer={stickyOffer}
          />
          {navigationBarTabList && <NavigationBar navigationBarTabList={navigationBarTabList} />}
        </NavigationRegion>
        <MainRegion key="main-region" className="main-region infosite__main">
          {isFailure && <ErrorLink />}
          <div ref={NavigationRefs.Overview} className="infosite__content infosite__content--details">
            <PropertyDetails
              {...hotel}
              reviews={reviews}
              goBack={this.goBack}
              index={0}
              priceGuarantee={priceGuarantee}
              roomsAndRatesTarget={roomsAndRatesTarget}
              stickyOffer={stickyOffer}
              favoriteButton={favoriteButton}
            />
            <InfositeMessagingCard
              errorBoundary="hotel.information.membership"
              testId="mod-signup-signin-banner"
              model={messagingCardModel && messagingCardModel.model}
            />
            <InfositeMessagingCard
              errorBoundaryLabel="hotel.information.freeLx"
              testId="free-lx-banner"
              model={offers && offers.freeLxMessagingCard && offers.freeLxMessagingCard.model}
            />

            {React.createElement(roomsAndRatesLoadable.codeSplit, {
              ...offers,
              forceHistoryPushOnGoBack: this.forceHistoryPushOnGoBack,
              infoModel: hotel,
              loadingOffers,
              onRoomsAndRatesTargetAvailable: this.setRoomsAndRatesTarget
            })}
            <SleepingArrangementsWrapper />
            {vrInquiryChatbotViewModel && <ChatBot model={vrInquiryChatbotViewModel} />}
            <SimilarHotels similarHotels={similarHotels} />

            {hotel && <WhatsAroundCard mapModel={hotel.mapModel} />}
            <SimilarHotels similarHotels={similarHotelsDateless} isDatelessPdp={isDateless} />
            <ActivityRecommendationsWrapper />

            <PropertyInformation />
            <DatelessFaqs isDateless={isDateless} propertyFaqs={propertyFaqs} siteId={siteId} trafficTestBucket={trafficTestBucket} />
            {reviews && reviews.userReviews && reviews.userReviews.length > 0 && <ReviewsOnInfosite currentHotel={currentHotel} />}
          </div>
          <MesoFooter pageName={PageName.INFOSITE} destination={destination} isDateless={isDateless} />

          <MesoIntentMediaExp pageName={PageName.INFOSITE} searchCriteria={searchCriteria} />
          <QueryRoute query={{ pwaDialog: 'rewardsEducation' }}>
            <RewardsEducationDialog rewardsEducation={rewardsEducation} />
          </QueryRoute>
          <WelcomeNotification />
          <SchemaOrgScript structuredData={structuredData} />
          {multiItem && !multiItem.isPackageShoppingPath() && <MultiItem pageName={PageName.INFOSITE} />}
        </MainRegion>
        <SideRailRegion key="side-rail-region">
          <MesoSideRail pageName={PageName.INFOSITE} />
        </SideRailRegion>
      </MasterPageWrapper>
    );
  }

  renderLayoutWithSdui() {
    const { currentHotel, l10n, page, route, routeStore, context, multiItem } = this.props;
    const { roomsAndRatesTarget } = this.state;

    const {
      hotel,
      hotelId,
      isFailure,
      loadingOffers,
      messagingCardModel,
      offers,
      reviews,
      searchCriteria,
      similarHotels,
      similarHotelsDateless,
      toolbar = {}
    } = currentHotel || {};
    const { gallery, hotelName, navigationBarTabList, propertyFaqs, shortlistModel, vrInquiryChatbotViewModel } = hotel || {};

    const stickyOffer = offers && offers.stickyOffer;
    const priceGuarantee = offers && offers.propertyInfo && offers.propertyInfo.priceGuarantee;
    const destination = searchCriteria && searchCriteria.destination;
    const isDateless = searchCriteria && searchCriteria.isDateless;
    const infositeContext = offers && offers.infositeContext;
    const backToHsrUrl = infositeContext && infositeContext.backToHsrUrl;
    const rewardsEducation = offers && offers.rewardsDialogContent && offers.rewardsDialogContent.rewardsEducation;

    if (!page.seo) {
      page.title = `${hotelName} ${destination ? `(${destination})` : ''}`;
    }
    const favoriteButton = shortlistModel && shortlistModel.meta && shortlistModel.meta.hotelId && (
      <FavoriteButton
        shortlistModel={shortlistModel}
        labelSave={l10n.formatText('hotels.infosite.shortlist.saveToList.a11yLabel')}
        labelRemove={l10n.formatText('hotels.infosite.shortlist.removeFromList.a11yLabel')}
        category="hotel"
        onSaveMessage={l10n.formatText('hotels.shortlist.saveToList.notification', hotelName)}
        id={`favorite-${hotelId}`}
        {...hotel}
        reviews={reviews}
      />
    );
    const masterProps = {
      className: 'infosite',
      dataStid: 'infosite-page-container',
      pageUsable: true,
      route,
      searchCriteria,
      toolbarType: MasterPageToolbarTypes.TOOLBAR_WHITE_BACKGROUND
    };

    const bentoLayoutName = routeStore && routeStore.queryParams && routeStore.queryParams.sduiPerfTest ? 'pdp-main-layout' : 'pdp-main';
    const structuredData = context && context.viewModelResponse && context.viewModelResponse.structuredData;
    const showReviews = reviews && reviews.count;
    const siteId = context && context.site && context.site.id;
    const trafficTestBucket =
      context &&
      context.viewModelResponse &&
      context.viewModelResponse.flexContext &&
      context.viewModelResponse.flexContext.experimentContext &&
      context.viewModelResponse.flexContext.experimentContext.experiments &&
      context.viewModelResponse.flexContext.experimentContext.experiments.FAQ_on_PDP_Traffic_Test;

    return (
      <MasterPageWrapper {...masterProps}>
        <NavigationRegion className="navigation-bar-region constrained">
          <BentoBox name="pdp-navigation">
            <BentoPortion name="pdp-property-summary">
              <PropertySummary
                {...hotel}
                reviews={reviews}
                backToHsrUrl={backToHsrUrl}
                name={toolbar.name}
                goBack={this.goBack}
                favoriteButton={favoriteButton}
                currentHotel={currentHotel}
                roomsAndRatesTarget={roomsAndRatesTarget}
                stickyOffer={stickyOffer}
              />
            </BentoPortion>
            <BentoPortion name="pdp-navbar">
              {navigationBarTabList && <NavigationBar navigationBarTabList={navigationBarTabList} />}
            </BentoPortion>
          </BentoBox>
        </NavigationRegion>
        <MainRegion key="main-region" className={`main-region infosite__main`}>
          {isFailure && <ErrorLink />}
          <div ref={NavigationRefs.Overview} className="infosite__content infosite__content--details" data-stid="bento_infosite">
            <BentoBox name={bentoLayoutName}>
              <BentoPortion name="pdp-property-details">
                <PropertyDetails
                  {...hotel}
                  reviews={reviews}
                  goBack={this.goBack}
                  index={0}
                  priceGuarantee={priceGuarantee}
                  roomsAndRatesTarget={roomsAndRatesTarget}
                  stickyOffer={stickyOffer}
                  favoriteButton={favoriteButton}
                />
              </BentoPortion>
              <BentoSideDish>
                <BentoPortion name="pdp-property-details-ronin">
                  <RoninPropertyDetails
                    {...hotel}
                    reviews={reviews}
                    goBack={this.goBack}
                    index={0}
                    priceGuarantee={priceGuarantee}
                    roomsAndRatesTarget={roomsAndRatesTarget}
                    stickyOffer={stickyOffer}
                    favoriteButton={favoriteButton}
                  />
                </BentoPortion>
              </BentoSideDish>

              <BentoPortion name="pdp-mod-banner">
                <InfositeMessagingCard
                  errorBoundary="hotel.information.membership"
                  testId="mod-signup-signin-banner"
                  model={messagingCardModel && messagingCardModel.model}
                />
              </BentoPortion>

              <BentoPortion name="pdp-lx-banner">
                <InfositeMessagingCard
                  errorBoundaryLabel="hotel.information.freeLx"
                  testId="free-lx-banner"
                  model={offers && offers.freeLxMessagingCard && offers.freeLxMessagingCard.model}
                />
              </BentoPortion>

              <BentoPortion name="pdp-rooms-and-rates">
                {React.createElement(roomsAndRatesLoadable.codeSplit, {
                  ...offers,
                  forceHistoryPushOnGoBack: this.forceHistoryPushOnGoBack,
                  infoModel: hotel,
                  loadingOffers,
                  onRoomsAndRatesTargetAvailable: this.setRoomsAndRatesTarget
                })}
              </BentoPortion>

              <BentoPortion name="pdp-sleeping-arrangements">
                <SleepingArrangementsWrapper l10n={l10n} offers={offers} />
              </BentoPortion>

              <BentoPortion name="pdp-chatbot">{vrInquiryChatbotViewModel && <ChatBot model={vrInquiryChatbotViewModel} />}</BentoPortion>

              <BentoPortion name="pdp-similar-hotels">
                <SimilarHotels similarHotels={similarHotels} />
              </BentoPortion>

              <BentoSideDish>
                <BentoPortion name="pdp-map-access">{hotel && <MapAccess mapModel={hotel.mapModel} />}</BentoPortion>
              </BentoSideDish>

              <BentoPortion name="pdp-whats-around">
                <ErrorBoundary label="hotel.information.whatsAround_1">
                  <>{hotel && <WhatsAroundCard mapModel={hotel.mapModel} />}</>
                </ErrorBoundary>
              </BentoPortion>

              <BentoPortion name="pdp-similar-hotels-dateless">
                <SimilarHotels similarHotels={similarHotelsDateless} isDatelessPdp={isDateless} />
              </BentoPortion>

              <BentoSideDish>
                <BentoPortion name="pdp-photo-gallery">
                  {gallery && (
                    <GalleryByCategories currentHotel={currentHotel} gallery={gallery} trackingRfrr="PhotoGalleryTab" id={hotelId} />
                  )}
                </BentoPortion>
              </BentoSideDish>

              <BentoPortion name="pdp-activities">
                <ActivityRecommendationsWrapper />
              </BentoPortion>

              <BentoPortion name="pdp-policies">
                <PropertyInformation />
              </BentoPortion>
              <BentoPortion name="pdp-faqs">
                <DatelessFaqs isDateless={isDateless} propertyFaqs={propertyFaqs} siteId={siteId} trafficTestBucket={trafficTestBucket} />
              </BentoPortion>
              <BentoPortion name="pdp-user-reviews">
                {showReviews ? <ReviewsOnInfosite currentHotel={currentHotel} /> : <NoReviews />}
              </BentoPortion>
            </BentoBox>
          </div>
          <MesoFooter pageName={PageName.INFOSITE} destination={destination} isDateless={isDateless} />
          <MesoIntentMediaExp pageName={PageName.INFOSITE} searchCriteria={searchCriteria} />
          <QueryRoute query={{ pwaDialog: 'rewardsEducation' }}>
            <RewardsEducationDialog rewardsEducation={rewardsEducation} />
          </QueryRoute>
          <WelcomeNotification />
          <SchemaOrgScript structuredData={structuredData} />
          {multiItem && !multiItem.isPackageShoppingPath() && <MultiItem pageName={PageName.INFOSITE} />}
        </MainRegion>
        <SideRailRegion key="side-rail-region">
          <MesoSideRail pageName={PageName.INFOSITE} />
        </SideRailRegion>
      </MasterPageWrapper>
    );
  }

  render() {
    return (
      <AbacusExperiment name="PWA_SDUI_TABBED_LAYOUT">
        <AbacusControl>{this.renderLayout()}</AbacusControl>
        <AbacusVariant bucket={1}>{this.renderLayoutWithSdui()}</AbacusVariant>
      </AbacusExperiment>
    );
  }
}

module.exports = Infosite;

const MasterPageWrapper = ({ children, ...masterProps }) => (
  <Viewport>
    <ViewSmall>
      <MasterPage
        {...masterProps}
        pageHeaderClassName="header--with-overlay-toolbar"
        toolbarType={MasterPageToolbarTypes.TRANSPARENT_OVERLAY}
      >
        {children}
      </MasterPage>
    </ViewSmall>
    <ViewLarge>
      <MasterPage
        {...masterProps}
        toolbarType={MasterPageToolbarTypes.NORMAL}
        sideRailType={
          masterProps.searchCriteria && masterProps.searchCriteria.isDateless ? '' : MasterPageSideRailTypes.NEXT_TO_MAIN_AND_TOOLBAR
        }
      >
        {children}
      </MasterPage>
    </ViewLarge>
  </Viewport>
);
